import React, {useState, useEffect, useRef} from 'react';
import styles from '../../../styles.module.scss';
import {Text, Dropdown, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {SearchDropdown} from '../../../../../components/commonOldtoNew';
import List from '../../../../../components/Common/List';
import texts from '../../../texts';
import {highlightText} from '../../../../../_legacy/library/utils/highlightText';
import {reportGeneratorsStore} from '../../../stores/ReportGeneratorsStore';
import {circularReplacer, getScalesFormData} from '../../../services/service';
import {useHover} from '../../../../../hooks/useHover';
import {helpPopoverRef} from '../../../../../_shared/Help/constants';
import {getHelpData} from '../../../utils';

const GaugeScalesSelector = ({title, onSelect, axisName, helpText}) => {
    const {currentReport} = reportGeneratorsStore.currentScreen;
    const [isOpen, setIsOpen] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState(null);
    const [query, setQuery] = useState<string>();
    const [selectedIndex, setselectedIndex] = useState<number>();

    const scaleOptions = useRef(null);
    const {setRef, isHovering} = useHover();

    const scalesFormHandler = async () => {
        const data = await getScalesFormData();
        const records = data.records.filter(record => record.fieldsMap.get(1).currentValue !== '');
        const fixedRecords = records.map(record => {
            const fixed = JSON.stringify(record, circularReplacer());
            return JSON.parse(fixed);
        });
        setFilteredOptions(fixedRecords);
        scaleOptions.current = fixedRecords;
    };
    const handleSelectItem = item => {
        setIsOpen(false);
        const itemValue = item.fieldsMap[0][1].currentValue;
        setselectedIndex(
            filteredOptions.findIndex(opt => opt.fieldsMap[0][1].currentValue === itemValue)
        );
        onSelect(item);
    };

    const handleClose = () => {
        setIsOpen(false);
        setQuery(null);
    };

    useEffect(() => {
        handleClose();
    }, [currentReport]);

    useEffect(() => {
        scalesFormHandler();
    }, []);

    useEffect(() => {
        if (query) {
            const lowerCaseQuery = query.toLowerCase();
            const newFilteredOptions = scaleOptions?.current?.filter(item =>
                item.fieldsMap?.[0]?.[1]?.currentValue?.toLowerCase().includes(lowerCaseQuery)
            );
            setFilteredOptions(newFilteredOptions);
        } else {
            setFilteredOptions(scaleOptions?.current);
        }
    }, [query, filteredOptions]);

    useEffect(() => {
        if (filteredOptions) {
            setselectedIndex(
                filteredOptions.findIndex(
                    opt => opt.fieldsMap[0][1].currentValue === axisName && axisName !== ''
                )
            );
        }
    }, [filteredOptions]);

    const handlePageDown = (index: number) => {
        const lastIndex = filteredOptions.length - 1;
        let nextIndex = Number(index) + 10;
        nextIndex = nextIndex > lastIndex ? lastIndex : nextIndex;
        return Promise.resolve({nextSelected: nextIndex});
    };

    const handlePageUp = selectedIndex => {
        let nextIndex = selectedIndex - 10;
        nextIndex = nextIndex >= 0 ? nextIndex : 0;
        return nextIndex;
    };

    const handleCheckBoxHelp = e => {
        e.stopPropagation();
        const helpData = getHelpData(texts.scaleChartHelp);
        helpPopoverRef.current.showHelpPopover({
            ...helpData,
            anchor: e.target
        });
    };

    const focsedIndex = query ? 0 : selectedIndex > -1 ? selectedIndex : 0;

    return (
        <div ref={setRef} className={styles.axisWrapper}>
            <Text skin="label-1" componentClasses={styles.titleWithHelp}>
                {title}
                {isHovering && (
                    <Icon onClick={handleCheckBoxHelp} skin="standart" icon={PriorityIcon.help} />
                )}
            </Text>
            <SearchDropdown
                openOnFocus
                onOpen={() => setIsOpen(true)}
                focusedIndex={focsedIndex}
                clearOnClose={false}
                closeOnClear={false}
                closeOnBlur={false}
                shouldHandleHomeAndEndPress
                selectedIndex={selectedIndex}
                handlePageDown={handlePageDown}
                handlePageUp={handlePageUp}
                inputProps={{
                    value: query ?? axisName,
                    onChange: setQuery,
                    returnFocus: false,
                    displayClear: isOpen,
                    placeholder: texts.gaugeScalePlaceHolder,
                    autoSelect: true,
                    size: 'large',
                    componentClasses: styles.searchInput
                }}
                onClose={handleClose}
                circularNavigation
                withDataTestId
            >
                <Dropdown.Content componentClasses={styles.fieldsList}>
                    <Dropdown.Section gradient>
                        {filteredOptions?.length > 0 ? (
                            <List
                                onScrollToEnd={() => {}}
                                autoHeight
                                autoHeightMax={200}
                                data={filteredOptions}
                                renderItem={({item, index}) => (
                                    <Dropdown.Item
                                        divider={
                                            filteredOptions && index !== filteredOptions.length - 1
                                        }
                                        onClick={() => handleSelectItem(item)}
                                        key={index}
                                        index={index}
                                    >
                                        <Text skin="paragraph-2" style={{color: 'black'}}>
                                            {highlightText(
                                                item.fieldsMap[0][1].currentValue,
                                                query,
                                                true,
                                                false,
                                                true
                                            )}
                                        </Text>
                                    </Dropdown.Item>
                                )}
                            />
                        ) : (
                            <Dropdown.Item disabled>
                                <Text componentClasses={styles.emptState} skin="paragraph-2">
                                    {texts.noMatchEmptyResults}
                                </Text>
                            </Dropdown.Item>
                        )}
                    </Dropdown.Section>
                </Dropdown.Content>
            </SearchDropdown>
        </div>
    );
};

export default GaugeScalesSelector;
